function setSessionStorage<T>(key: string, item: T) {
  sessionStorage.setItem(key, JSON.stringify(item));
}

function getSessionStorage<T>(key: string): T | null {
  try {
    const item = sessionStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  } catch {
    return null;
  }
}

const STORAGE_VERSION_DATE = "09-18-2025";

const TABLE_STATE_VERSION_DATE = "04-27-2026";

const clearOldLocalStorage = (keyPrefix: string, versionDate: string = STORAGE_VERSION_DATE) => {
  Object.keys(localStorage)
    .filter((key) => key.toLowerCase().startsWith(keyPrefix.toLowerCase()) && !key.includes(versionDate))
    .forEach((key) => localStorage.removeItem(key));
};

const clearLocalStorageByKeyPrefix = (keyPrefix: string) => {
  Object.keys(localStorage)
    .filter((key) => key.toLowerCase().startsWith(keyPrefix.toLowerCase()))
    .forEach((key) => localStorage.removeItem(key));
};

export {
  clearOldLocalStorage,
  setSessionStorage,
  getSessionStorage,
  STORAGE_VERSION_DATE,
  TABLE_STATE_VERSION_DATE,
  clearLocalStorageByKeyPrefix,
};
